import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

export const useQueryParams = () => {
  const { search } = useLocation()
  return queryString.parse(search)
}
